import {
	RuleTemplateConfigDTO,
	RuleTemplateDTO,
	RuleTemplateVisibility
} from 'api-models'
import { ApiClient } from '../api-client'

/** Rule templates (DEV-2403 §5). Workspace-scoped: `list` returns the caller's own
 *  plus everything shared, and the server rejects a mutation on someone else's row. */
async function listTemplates(props: {
	accountId?: string | null
}): Promise<RuleTemplateDTO[]> {
	const { data } = await ApiClient.client.get(
		`/accounts/${props.accountId}/rule-templates`
	)
	return data.data
}

async function createTemplate(props: {
	accountId?: string | null
	payload: {
		asset_id: string
		name: string
		description?: string
		visibility: RuleTemplateVisibility
		rule_data: RuleTemplateConfigDTO
	}
}): Promise<RuleTemplateDTO> {
	const { data } = await ApiClient.client.post(
		`/accounts/${props.accountId}/rule-templates`,
		props.payload
	)
	return data.data
}

async function updateTemplate(props: {
	accountId?: string | null
	templateId: string
	payload: {
		/** The website whose entity ids `rule_data.scope` now holds — sent so the two
		 *  cannot drift apart. See `applyTemplateScope`. */
		asset_id?: string
		name?: string
		description?: string
		rule_data?: RuleTemplateConfigDTO
	}
}): Promise<RuleTemplateDTO> {
	const { data } = await ApiClient.client.put(
		`/accounts/${props.accountId}/rule-templates/${props.templateId}`,
		props.payload
	)
	return data.data
}

/** "Make shared" / "Make private" — the only field the library's tray moves. */
async function setTemplateVisibility(props: {
	accountId?: string | null
	templateId: string
	visibility: RuleTemplateVisibility
}): Promise<RuleTemplateDTO> {
	const { data } = await ApiClient.client.patch(
		`/accounts/${props.accountId}/rule-templates/${props.templateId}/visibility`,
		{ visibility: props.visibility }
	)
	return data.data
}

async function deleteTemplate(props: {
	accountId?: string | null
	templateId: string
}): Promise<void> {
	await ApiClient.client.delete(
		`/accounts/${props.accountId}/rule-templates/${props.templateId}`
	)
}

export const RuleTemplates = {
	listTemplates,
	createTemplate,
	updateTemplate,
	setTemplateVisibility,
	deleteTemplate
}
